/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FindAllScreenerLeadWaitlistResponse } from './FindAllScreenerLeadWaitlistResponse';
import {
    FindAllScreenerLeadWaitlistResponseFromJSON,
    FindAllScreenerLeadWaitlistResponseFromJSONTyped,
    FindAllScreenerLeadWaitlistResponseToJSON,
} from './FindAllScreenerLeadWaitlistResponse';

/**
 * 
 * @export
 * @interface FindAllScreenerLeadWaitlist200Response
 */
export interface FindAllScreenerLeadWaitlist200Response {
    /**
     * 
     * @type {FindAllScreenerLeadWaitlistResponse}
     * @memberof FindAllScreenerLeadWaitlist200Response
     */
    data?: FindAllScreenerLeadWaitlistResponse;
}

/**
 * Check if a given object implements the FindAllScreenerLeadWaitlist200Response interface.
 */
export function instanceOfFindAllScreenerLeadWaitlist200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FindAllScreenerLeadWaitlist200ResponseFromJSON(json: any): FindAllScreenerLeadWaitlist200Response {
    return FindAllScreenerLeadWaitlist200ResponseFromJSONTyped(json, false);
}

export function FindAllScreenerLeadWaitlist200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllScreenerLeadWaitlist200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : FindAllScreenerLeadWaitlistResponseFromJSON(json['data']),
    };
}

export function FindAllScreenerLeadWaitlist200ResponseToJSON(value?: FindAllScreenerLeadWaitlist200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': FindAllScreenerLeadWaitlistResponseToJSON(value.data),
    };
}

